// extracted by mini-css-extract-plugin
export default {"form":"SectionForm_form__7genr","container":"SectionForm_container__72k-C","formInputs":"SectionForm_formInputs__iNY3x","formSubmit":"SectionForm_formSubmit__JcSIc"};